import React from "react";
import {
  Button,
  Card,
  FormCheck,
  FormControl,
  ListGroup,
} from "react-bootstrap";

import ConfirmDelete from "./ConfirmDelete";

interface IOpcaoPersonalizacao {
  id?: number;
  nome: string;
}

interface IConfPersonalizacaoSelecaoProps {
  titulo: string;
  obrigatorio: boolean;

  opcoes: IOpcaoPersonalizacao[];

  multipla: boolean;
  novaOpcao: string;

  onDelete: () => void;

  onTitleChange: (
    titulo: string
  ) => void;

  onOptionsChange: (
    opcoes: IOpcaoPersonalizacao[]
  ) => void;

  onNovaOpcaoChange: (
    valor: string
  ) => void;

  onRequiredChange: (
    obrigatorio: boolean
  ) => void;
}

export function ConfPersonalizacoeselecao({
  titulo,
  obrigatorio,
  novaOpcao,
  opcoes,
  onTitleChange,
  onNovaOpcaoChange,
  onDelete,
  onOptionsChange,
  onRequiredChange,
  multipla,
}: IConfPersonalizacaoSelecaoProps) {
  function adicionarOpcao() {
    const valor = novaOpcao.trim();

    if (!valor) return;

    onOptionsChange([
      ...opcoes,
      {
        nome: valor,
      },
    ]);

    onNovaOpcaoChange("");
  }

  function removerOpcao(
    index: number
  ) {
    onOptionsChange(
      opcoes.filter(
        (_, i) => i !== index
      )
    );
  }

  function editarOpcao(
    index: number,
    valor: string
  ) {
    const novasOpcoes = [
      ...opcoes,
    ];

    novasOpcoes[index] = {
      ...novasOpcoes[index],
      nome: valor,
    };

    onOptionsChange(
      novasOpcoes
    );
  }

  return (
    <Card>
      <Card.Header
        style={{
          display: "flex",
          justifyContent:
            "space-between",
        }}
      >
        <Card.Title>
          {multipla
            ? "Personalização de Seleção Múltipla"
            : "Personalização de Seleção"}
        </Card.Title>

        <ConfirmDelete
          onDelete={onDelete}
        />
      </Card.Header>

      <Card.Body>
        <div className="mb-3">
          <label>Título</label>

          <FormControl
            value={titulo}
            onChange={(e) =>
              onTitleChange(
                e.target.value
              )
            }
          />
        </div>

        <div className="mb-3">
          <label>
            Nova opção
          </label>

          <div className="d-flex gap-2">
            <FormControl
              value={novaOpcao}
              onChange={(e) =>
                onNovaOpcaoChange(
                  e.target.value
                )
              }
            />

            <Button
              onClick={
                adicionarOpcao
              }
            >
              Adicionar
            </Button>
          </div>
        </div>

        <ListGroup className="mb-3">
          {opcoes.map(
            (
              opcao,
              index
            ) => (
              <ListGroup.Item
                key={
                  opcao.id ??
                  index
                }
                className="d-flex gap-2"
              >
                <FormControl
                  value={
                    opcao.nome
                  }
                  onChange={(
                    e
                  ) =>
                    editarOpcao(
                      index,
                      e.target
                        .value
                    )
                  }
                />

                <ConfirmDelete
                  onDelete={() =>
                    removerOpcao(
                      index
                    )
                  }
                />
              </ListGroup.Item>
            )
          )}
        </ListGroup>

        <FormCheck
          type="checkbox"
          label="Obrigatório"
          checked={
            obrigatorio
          }
          onChange={(e) =>
            onRequiredChange(
              e.target.checked
            )
          }
        />
      </Card.Body>
    </Card>
  );
}

export default ConfPersonalizacoeselecao;